import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { OffsetPagination } from '@/@diffrag/OffsetPagination'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { TableFormatter } from '@/@diffrag/table/TableFormatter'
import { api } from '@/api'
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { IAdminCommunityRO, StatusEnum8 } from 'api'
import { useNavigate } from 'react-router-dom'

const BOARD_LIST = [
  {
    label: '전체',
    value: undefined,
  },
  {
    label: '공지사항',
    value: 1,
  },
  {
    label: 'Emotion',
    value: 2,
  },
  {
    label: 'Health',
    value: 3,
  },
  {
    label: '메디컬 커뮤니티',
    value: 5,
  },
]

const STATUS_OPTIONS = [
  {
    label: '전체',
    value: undefined,
  },
  {
    label: '노출',
    value: StatusEnum8.VISIBLE,
  },
  {
    label: '비노출',
    value: StatusEnum8.HIDDEN,
  },
]

export default function Notice() {
  const q = useQueryValue('q', undefined)
  const page = useQueryValue('page', 1)
  const navigate = useNavigate()

  const [selectedStatus, setSelectedStatus] = useState<StatusEnum8 | undefined>(
    undefined,
  )

  const { data, isFetching, refetch } = useApi({
    id: 'communityList',
    fn: api().adminCommunity.getCommunityArticleList,
    params: {
      page,
      pageSize: 20,
      q,
      categoryId: undefined,
      boardId: 1,
      status: selectedStatus,
    },
  })

  const onDelete = async (rows: IAdminCommunityRO[]) => {
    try {
      await Promise.all(
        rows.map((row) => api().adminCommunity.deleteCommunityArticle(row.id)),
      )

      refetch()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ContentView>
      <div className="mb-4 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">상태:</span>
          <div className="flex gap-2">
            {STATUS_OPTIONS.map((status) => (
              <Button
                key={status.value || 'all'}
                variant={
                  selectedStatus === status.value ? 'default' : 'outline'
                }
                size="sm"
                onClick={() => setSelectedStatus(status.value)}
                className="min-w-[80px]"
              >
                {status.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
      <SimpleTable
        isLoading={isFetching}
        data={data?.rows}
        onDelete={onDelete}
        options={{
          disableSort: true,
          disableNew: false,
        }}
        createHref="/notice/edit"
        onRowClick={(row) => {
          navigate(`/notice/edit?id=${row.id}`)
        }}
        columns={[
          {
            key: 'title',
            label: '제목',
            isPrimary: true,
            href: (data) => `/notice/edit?id=${data.id}`,
          },
          {
            key: 'author.userData.nickname',
            label: '작성자',
            width: 120,
          },
          {
            key: 'createDate',
            label: '작성일',
            formatter: TableFormatter.datetime(),
            width: 150,
          },
          {
            key: 'articleStatus',
            label: '상태',
            valueMap: {
              VISIBLE: '노출',
              HIDDEN: '비노출',
            },
            width: 50,
          },
        ]}
      />
      <OffsetPagination total={data?.count} page={page} pageSize={20} />
    </ContentView>
  )
}
